import { SortOrder } from 'kentico-cloud-delivery';
import Client from './kenticoClient';
import { KENTICO_TYPES } from 'common/consts/kentico';

export const CASE_STUDY_LIMIT = 14;

class SimpleCaseStudyService {
  async fetchCaseStudies({ limit = CASE_STUDY_LIMIT, page = 1, category }) {
    const skip = (page - 1) * limit;
    const query = Client.items()
      .type(KENTICO_TYPES.SIMPLE_CASE_STUDY)
      .orderParameter('elements.data_publikacji', SortOrder.desc)
      .limitParameter(limit)
      .skipParameter(skip);

    if (category) {
      query.equalsFilter('elements.spolka[any]', category.toLowerCase());
    }
    return query.toPromise();
  }
}

export default new SimpleCaseStudyService();



// WEBPACK FOOTER //
// ./src/services/SimpleCaseStudy.service.js